import { render } from "./EmailTemplateList.molecules.vue?vue&type=template&id=1d37bb8a&ts=true"
import script from "./EmailTemplateList.molecules.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateList.molecules.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__